import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";

interface SubscriptionState {
  subscription: any;
  paymentDetails: any;
  blockedUsers: any;
  loading: boolean;
  error: string | null;
  Gsettings:any;
  getSubscription: (userId: number) => Promise<void>;
  blockUserList: (param: { page: number; limit: number; id: number }) => Promise<void>;
  handleUnblock: (blockId: string, userId:number) => Promise<void>;
  deletePaymentProfile: (user_id: number, cardId: string) => Promise<void>;
  updateSubscriptionPaymentProfile: (userId: number, cardId: string) => Promise<void>;
  cancelSubscription: (userId: number, sub: string ) => Promise<void>;
  getSettings:() => Promise<void>;
}

export const useSubscriptionStore = create<SubscriptionState>((set, get) => ({
  subscription: null,
  paymentDetails: null,
  blockedUsers: null,
  loading: false,
  error: null,
  Gsettings:null,

  getSubscription: async (userId) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.post(`/getSubscription`, { userId });

      if (response.data.paymentDetails && !response.data.subscription) {
        
        set({ paymentDetails: response.data.paymentDetails, subscription: null });
      } else {
        set({ subscription: response.data, paymentDetails: response.data.paymentDetails });
      }
     
    } catch (error: any) {
      console.error("Error fetching subscription:", error);
      set({ error: error.response?.data?.message || "Failed to fetch subscription details" });
    } finally {
      set({ loading: false });
    }
  },

  blockUserList: async (param) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.post(`/blockedUsers`, param);
      set({ blockedUsers: response.data });
    } catch (error: any) {
      console.error("Error fetching blocked users:", error);
      set({ error: error.response?.data?.message || "Failed to fetch blocked users" });
    } finally {
      set({ loading: false });
    }
  },

  handleUnblock: async (blockId: string, userId:number) => {
    set({ loading: true, error: null });
    try {
       await axiosInstance.post(`/unblockUser`, { id: blockId });

      // After unblocking, you may want to refresh the blocked user list
      // const { blockedUsers } = get();
      // const updatedList = blockedUsers?.rows?.filter((user: any) => user.id !== parseInt(response.data));
      // set({ blockedUsers: { ...blockedUsers, rows: updatedList } });
      get().blockUserList({page:0,limit:10,id:userId});
    } catch (error: any) {
      console.error("Error unblocking user:", error);
      set({ error: error.response?.data?.message || "Failed to unblock user" });
    } finally {
      set({ loading: false });
    }
  },

  deletePaymentProfile: async (user_id, cardId) => {
    set({ loading: true, error: null });
    try {
      await axiosInstance.post(`/deletePaymentProfile`, { user_id, cardId });

      // Optionally update UI by removing deleted card from paymentDetails
      const { paymentDetails } = get();
      if (paymentDetails?.length) {
        const updated = paymentDetails.filter((card: any) => card.card_id !== cardId);
        set({ paymentDetails: updated });
      }

    } catch (error: any) {
      console.error("Error deleting payment profile:", error);
      set({ error: error.response?.data?.message || "Failed to delete payment profile" });
    } finally {
      set({ loading: false });
    }
  },
  updateSubscriptionPaymentProfile: async (userId, cardId) => {
    set({ loading: true, error: null });
    try {
      await axiosInstance.post(`/updateSubscriptionPaymentProfile`, { user_id: userId, cardId });
      // Refresh subscription data after update
      await get().getSubscription(userId);
    } catch (error: any) {
      console.error("Error updating subscription payment profile:", error);
      set({ error: error.response?.data?.message || "Failed to update subscription payment profile" });
    } finally {
      set({ loading: false });
    }
  },
  cancelSubscription: async (userId, sub) => {
    set({ loading: true, error: null });
    try {
      await axiosInstance.post(`/cancelSubscription`, { user_id: userId, sub });
      // Refresh subscription data after cancel
      await get().getSubscription(userId);
   
    } catch (error: any) {
      console.error('Error cancelling subscription:', error.response?.data || error.message);
    } finally {
      set({ loading: false });
    }
  },
  getSettings: async () => {
    set({ loading: true, error: null });
    try {
      const response =  await axiosInstance.get(`/get-settings`);
      set({ Gsettings: response.data });
    } catch (error: any) {
      console.error('Error cancelling subscription:', error.response?.data || error.message);
    } finally {
      set({ loading: false });
    }
  },
}));
